// extracted by mini-css-extract-plugin
export var badge = "badges-module--badge--3432e";
export var badgesFixedWrapper = "badges-module--badgesFixedWrapper--85fc0";